var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H17.8C18.9201 10 19.4802 10 19.908 10.218C20.2843 10.4097 20.5903 10.7157 20.782 11.092C21 11.5198 21 12.0799 21 13.2V20M13 20V5.2C13 4.0799 13 3.51984 12.782 3.09202C12.5903 2.71569 12.2843 2.40973 11.908 2.21799C11.4802 2 10.9201 2 9.8 2H6.2C5.0799 2 4.51984 2 4.09202 2.21799C3.71569 2.40973 3.40973 2.71569 3.21799 3.09202C3 3.51984 3 4.0799 3 5.2V20M22 20H2M6.5 6H9.5M6.5 10H9.5M6.5 14H9.5",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customer-icon.988edf9971a36a36d583ab0b44bece1d.svg";
export { ForwardRef as ReactComponent };